function windowAccessible() {
    return typeof window !== "undefined";
}

export default windowAccessible;
